import "core-js/modules/es7.array.includes.js";
/**
 * Cada componente do painel guarda a própria cor de fundo dentro do seu objeto de
 * estilo (backgroundColor / backgroundColorPrioritary). As cores compartilhadas
 * (primaryColor, secondaryColor e prioritaryColor) continuam existindo apenas como
 * fallback para as configurações salvas antes dessa mudança.
 */
var SHARED_COLOR_FALLBACK = {
  containerPainelNameHeader: "primaryColor",
  containerPatientAndLocalCall: "primaryColor",
  containerLastCallHistory: "primaryColor",
  containerPatientAndCodeCallHistory: "primaryColor",
  containerPatientAndLocalCallPrioritary: "prioritaryColor",
  hourHistory: "primaryColor",
  footer: "secondaryColor"
};

// a hora do histórico era o único texto pintado com a cor compartilhada
var TEXT_COLOR_FALLBACK_ELEMENTS = ["hourHistory"];

// as cores compartilhadas são elementos de estilo por si só (a barra do
// cabeçalho é editada direto na secondaryColor), mas guardam o valor em `color`
var SHARED_COLOR_ELEMENTS = ["primaryColor", "secondaryColor", "prioritaryColor"];
export function backgroundColorKey(isPrioritary) {
  return isPrioritary ? "backgroundColorPrioritary" : "backgroundColor";
}
export function backgroundColorField(elementType) {
  var isPrioritary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return SHARED_COLOR_ELEMENTS.includes(elementType) ? "color" : backgroundColorKey(isPrioritary);
}
export function sharedColorFallback(configStylePainel, elementType, isPrioritary) {
  var _configStylePainel$ke;
  var key = isPrioritary ? "prioritaryColor" : SHARED_COLOR_FALLBACK[elementType];
  return configStylePainel === null || configStylePainel === void 0 || (_configStylePainel$ke = configStylePainel[key]) === null || _configStylePainel$ke === void 0 ? void 0 : _configStylePainel$ke.color;
}
export function getBackgroundColor(configStylePainel, elementType) {
  var _configStylePainel$el;
  var isPrioritary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var ownColor = configStylePainel === null || configStylePainel === void 0 || (_configStylePainel$el = configStylePainel[elementType]) === null || _configStylePainel$el === void 0 ? void 0 : _configStylePainel$el[backgroundColorField(elementType, isPrioritary)];
  return ownColor || sharedColorFallback(configStylePainel, elementType, isPrioritary);
}
export function getTextColor(configStylePainel, elementType) {
  var _configStylePainel$el2;
  var isPrioritary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var ownColor = configStylePainel === null || configStylePainel === void 0 || (_configStylePainel$el2 = configStylePainel[elementType]) === null || _configStylePainel$el2 === void 0 ? void 0 : _configStylePainel$el2.color;
  if (ownColor || !TEXT_COLOR_FALLBACK_ELEMENTS.includes(elementType)) {
    return ownColor;
  }
  return sharedColorFallback(configStylePainel, elementType, isPrioritary);
}